<template>
  <div v-cloak class="cart-preview">
    <div
      v-if="products && products.length"
      class="products container pt-4 p-2-touch"
    >
      <div v-for="p in products" :key="p.id" class="columns product-row mb-2">
        <div class="column is-2 product-row-image">
          <div class="product-image">
            <figure class="image is-16by9">
              <img :src="p.images['16by9']" />
            </figure>
          </div>
        </div>
        <div class="column is-6 product-row-desc">
          <div class="title">
            {{ p.name }}
          </div>
          <div class="description" v-html="p.description" />
          <div v-if="p.type === 'package'" class="mt-1">
            <b>Package contains:</b>
            <ul>
              <li
                v-for="package_product in p.package"
                :key="package_product.id"
              >
                <a :href="package_product.url" target="_blank">{{
                  package_product.name
                }}</a>
                <b>({{ package_product.quantity }})</b>
              </li>
            </ul>
          </div>
        </div>
        <div class="column is-1 product-row-qty">
          <i
            class="fa fa-angle-up cursor-is-pointer is-hidden-touch"
            @click="addToCart({ product_id: p.id, quantity: 1 })"
          />
          <i
            class="fa fa-angle-left cursor-is-pointer is-hidden-desktop pr-1-touch"
            @click="addToCart({ product_id: p.id, quantity: -1 })"
          />
          <input
            v-model="p.quantity"
            type="number"
            class="qty"
            min="1"
            onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
            @input="updateQty(p, $event)"
          />
          <i
            class="fa fa-angle-down cursor-is-pointer is-hidden-touch"
            @click="addToCart({ product_id: p.id, quantity: -1 })"
          />
          <i
            class="fa fa-angle-right cursor-is-pointer is-hidden-desktop pl-1-touch"
            @click="addToCart({ product_id: p.id, quantity: 1 })"
          />
        </div>
        <div class="column is-3 product-row-price">
          <a
            href="#"
            class="remove"
            title="Remove from cart"
            @click.prevent="removeFromCart(p)"
          >
            <i class="fa fa-remove" />
          </a>
          <div class="price price--product-row">
            <div class="final" v-html="formatPrice(p.price, p.quantity)" />
          </div>
        </div>
      </div>
    </div>
    <div class="container is-full is-white pt-2 pb-2">
      <div class="container">
        <div class="totals">
          <div class="block">
            <div class="name">
              Sub Total:
            </div>
            <div class="price">
              <div class="final" v-html="`${formatPrice(subTotal)}`" />
            </div>
          </div>
          <i
            class="fa fa-angle-right fa-5x is-hidden-touch"
            aria-hidden="true"
          />
          <i
            class="fa fa-angle-down fa-5x is-hidden-desktop"
            aria-hidden="true"
          />

          <div class="block">
            <div class="name">
              Discount:
            </div>
            <div class="price">
              <div class="final" v-html="formatPrice(discount * -1)" />
            </div>
          </div>
          <i
            class="fa fa-angle-right fa-5x is-hidden-touch"
            aria-hidden="true"
          />
          <i
            class="fa fa-angle-down fa-5x is-hidden-desktop"
            aria-hidden="true"
          />

          <div v-if="!has_automatically_applied_voucher" class="block">
            <div class="name">
              Voucher:
            </div>
            <Voucher />
          </div>
          <i v-if="!has_automatically_applied_voucher"
            class="fa fa-angle-right fa-5x is-hidden-touch"
            aria-hidden="true"
          />
          <i
            class="fa fa-angle-down fa-5x is-hidden-desktop"
            aria-hidden="true"
          />

          <div class="block">
            <div class="name">
              Total:
            </div>
            <div class="price">
              <div class="final" v-html="formatPrice(total)" />
            </div>
          </div>

          <a
            href="/cart/credentials"
            class="button is-outlined is-flts-blue
                        is-large align-vertical ml-1  mt-1-touch"
          >
            Proceed
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Cart from '../../mixins/Cart';
import Voucher from './Voucher';

export default {
  name: 'Cart',

  components: {
    Voucher
  },

  mixins: [Cart],

  props: {
    has_automatically_applied_voucher: { type: Boolean, default: false }
  },

  watch: {
    products() {
      if (this.products.length > 0) {
        VueEventHub.$emit('view-cart', this.products); // Cart view
        VueEventHub.$emit('begin-checkout', this.products);
      }
    }
  },

  methods: {
    updateQty: _.debounce(function t(p, event) {
      this.addToCart({
        product_id: p.id,
        quantity: parseInt(event.target.value, 10),
        update: true
      });
    }, 500)
  }
};
</script>
